<template>
  <div>
    <el-dialog
      :title="titleMenu[btnType]"
      :visible.sync="centerDialogVisible"
      width="400px"
      center>
      <div class="word">{{wordMenu[btnType]}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="close">取 消</el-button>
        <el-button class="confirm" size="medium" type="primary" @click="handleAction(btnType)">{{btnMenu[btnType]}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { withdrawal, agree, reject } from '@/api/marketPromotion'
export default {
  data () {
    return {
      activityId: '', // 活动id
      activityType: '', // 活动类型
      actionApi: '', // 公共方法处理接口
      centerDialogVisible: false,
      btnType: '', // 按钮类型
      // pageType: '', // 那个页面要跳转到列表页
      router: '', // 跳转
      titleMenu:{
        'agree': '审核确认',
        'refused': '驳回确认',
        'withdraw': '撤回确认' 
      },
      wordMenu: {},
      btnMenu: {
        'agree': '同意',
        'refused': '确认驳回',
        'withdraw': '确认撤回' 
      }
    }
  },
  methods: {
    init (btnType, { activityId, activityType }, router, tip, perTip) {
      // 精准营销同意按钮单独处理
      if (perTip) {
        // wordMenuTip = tip ? tip : '活动'
        this.wordMenu = {
          'agree': `${perTip}`,
          'refused': `请确认是否驳回${tip}提报信息`,
          'withdraw': `请确认是否撤回${tip}提报信息`
        }
      } else {
        // wordMenuTip = tip ? tip : '活动'
        this.wordMenu = {
          'agree': `请确认是否同意${tip}提报信息`,
          'refused': `请确认是否驳回${tip}提报信息`,
          'withdraw': `请确认是否撤回${tip}提报信息`
        }
      }
      this.btnType = btnType
      // this.pageType = pageType
      this.activityId = activityId
      this.activityType = activityType
      if (router) this.router = router
      this.centerDialogVisible = true
    },
    close () {
      this.$track.clickEvent('审核中心-操作弹窗', '1628236484', { tysj_trade_type: 1 })
      this.centerDialogVisible = false
    },
    async handleAction (btnType) {
      let type
      // 处理接口
      switch (btnType) {
        case 'withdraw':
          // 只有抽奖宝撤回按钮需要activityType这个参数
          this.actionApi = withdrawal
          type = 4
          this.commonApi(this.activityType)
          break
        case 'refused':
          this.actionApi = reject
          type = 2
          this.commonApi()
          break
        case 'agree':
          this.actionApi = agree
          type = 1
          this.commonApi()
          break
      }
      this.$track.clickEvent('审核中心-操作弹窗', '1628236485', { tysj_trade_type: type })
    },
    // 公共处理接口
    async commonApi (activityType) {
      try {
        const { code } = await this.actionApi({ activityId: this.activityId, activityType })
        if(code !== 200) return
        // 如果存在路由则跳转回页面
        if(this.router) {
          this.$router.push({ path: this.router })
        } else {
          this.$emit('actionModel')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.centerDialogVisible = false
      }
    }
  }
}
</script>
<style scoped lang="less">
.word{
  width: 100%;
  text-align: center;
}
.el-button{
  width: 100px;
  height: 40px;
}
.confirm{
  background: #4B7EFE;
}
/deep/.el-dialog .el-dialog__body{
  padding: 40px 20px;
}
</style>
